import React from 'react'
import Header from 'src/components/header/Header'
import Sidebar from 'src/components/sidebar/Sidebar'

const AuthLayout = ({children}) => {
  return (
    <>
    <Header />

    <div className="flex flex-1">
<Sidebar />
<div className=' w-full h-[calc(100vh-64px)] overflow-y-auto'>
      {children}
</div>
    </div>
    </>
  )
}

export default AuthLayout
